import { render, staticRenderFns } from "./viewUpload.vue?vue&type=template&id=ef2f33d6"
import script from "./viewUpload.vue?vue&type=script&lang=js"
export * from "./viewUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports